// XXX KB-6021 - display percentile number as a whole % instead of a fraction
export const getPercentileValue = (percentile: number) =>
  Number((percentile * 100).toFixed());
